import { Box, Drawer, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';


const DrawerCustom = ({ children, show , toggleDrawer }) => {
    
    const handleToggleClose = () => {
        toggleDrawer(false)
    }

    return (
        <Drawer open={show} anchor="top" onClose={ () => {}}>
            <Box sx={{ width: 'auto', px: 3, pb: 3, pt: 8 }} role="presentation">
                <IconButton
                    onClick={handleToggleClose}
                    sx={{ position: 'absolute', right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
                {children}
            </Box>
        </Drawer>

    )
}

export default DrawerCustom;
